import { useContext } from 'react';
import SectionWrapper from '@/home/common/SectionWrapper';
import VehicleCarousel from '@/home/common/VehicleCarousel';
import LoadingVehicleCarousel from '@/home/common/VehicleCarousel/LoadingVehicleCarousel';
import VehicleTile from '@/home/common/VehicleCarousel/VehicleTile';
import { useFavoritesIds } from '~/context/common/UserContext';
import AvailabilityAndPriceContext from '~/context/home/AvailabilityAndPriceContext';
import RecentVehiclesContext from '~/context/home/RecentVehiclesContext';
import { useToggleFavorite } from '~/hooks/common/favorites';
import useTileSharedProps from '~/hooks/home/useTileSharedProps';

export default function RecentlyViewed() {
  const {
    recentVehiclesFromSearch: {
      data: recentVehicles,
      hasError,
      isLoading,
      isLoaded
    },
    recentVehiclesFromRcb: { isLoading: rcbRecentVehiclesIsLoading }
  } = useContext(RecentVehiclesContext);
  const {
    pageAvailability: { data: availabilityData },
    pagePricing: { data: pricingData }
  } = useContext(AvailabilityAndPriceContext);
  const favoriteIds = useFavoritesIds();
  const toggleFavorite = useToggleFavorite();
  const sharedProps = useTileSharedProps();

  if (rcbRecentVehiclesIsLoading || isLoading) {
    return (
      <SectionWrapper analyticsSection="Recently Viewed Carousel">
        <LoadingVehicleCarousel hasBottomBorder />
      </SectionWrapper>
    );
  }

  if (hasError || (isLoaded && recentVehicles.length === 0)) return null;

  return (
    <SectionWrapper analyticsSection="Recently Viewed Carousel">
      <VehicleCarousel hasBottomBorder headerTitle="Recently viewed">
        {recentVehicles.map(v => {
          const { vehicleId } = v;

          const tileAvailability = availabilityData[vehicleId];

          return (
            <VehicleTile
              availabilityInfo={{
                pickup: tileAvailability?.soonestPickup?.content ?? undefined,
                delivery:
                  tileAvailability?.soonestDelivery?.content ?? undefined
              }}
              favoriteIds={favoriteIds}
              financeInfo={pricingData[vehicleId] ?? undefined}
              key={v.vehicleId}
              sectionTitle="recently viewed"
              sharedProps={sharedProps}
              toggleFavorite={toggleFavorite}
              vehicle={v}
            />
          );
        })}
      </VehicleCarousel>
    </SectionWrapper>
  );
}
